import { useCallback, useState } from 'react';
export default function useZoom(_zoom = 1, min = 0.1, max = 2, magnification = 0.1) {
    const [zoom, setZoom] = useState(_zoom);
    const isMin = zoom === min;
    const isMax = zoom === max;
    const handleZoomIn = useCallback(() => {
        if (zoom + magnification <= max) {
            setZoom((zm) => Number.parseFloat((zm + magnification).toFixed(3)));
        }
    }, [zoom, max, magnification]);
    const handleZoomOut = useCallback(() => {
        if (zoom - magnification >= min) {
            setZoom((zm) => Number.parseFloat((zm - magnification).toFixed(3)));
        }
    }, [zoom, magnification, min]);
    const handleZoomChange = useCallback((zoomValue) => {
        setZoom(zoomValue);
    }, []);
    const handleResetZoom = useCallback(() => {
        setZoom(_zoom);
    }, [_zoom]);
    return {
        zoom,
        isMax,
        isMin,
        handleZoomChange,
        handleResetZoom,
        handleZoomIn,
        handleZoomOut,
    };
}
